import React from "react";
import { getCollectionSpecRows } from "../pages/collectionItemUtils";

export default function CollectionItemParametry({ d }) {
    const specRows = getCollectionSpecRows(d || {});

    return (
        <div className="retro-spec-block">
            <div className="retro-spec-grid">
                {specRows.length > 0 ? (
                    specRows.map((row) => (
                        <div className="retro-spec-cell" key={row.label}>
                            <p>{row.label}</p>
                            <strong>{row.value}</strong>
                        </div>
                    ))
                ) : (
                    <div className="retro-item-empty">Specyfikacja czeka na uzupełnienie.</div>
                )}
            </div>


        </div>
    );
}
